import { Button } from "@mui/material";
import { shades } from "../theme";

const CustomButton = ({ sx = {}, ...props }) => (
  <Button
    {...props}
    sx={{
      backgroundColor: shades.customDark[500],
      color: "white",
      minHeight: "36px",
      padding: "12px 20px",
      transition: "all 0.18s cubic-bezier(.4,2,.6,1)",
      "&:hover": {
        backgroundColor: shades.secondary[500],
        color: "#fff",
        transform: "scale(1.08)",
        boxShadow: "0 4px 24px rgba(214,0,28,0.18)",
      },
      "&:active": {
        backgroundColor: "#ffe600",
        color: "#222",
        transform: "scale(0.96)",
        boxShadow: "0 2px 8px rgba(255,230,0,0.18)",
      },
      ...sx,
    }}
  />
);

export default CustomButton;
